import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './NavigationProgress.css';

const NavigationProgress = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const location = useLocation();

  useEffect(() => {
    // Start loading animation when location changes
    setIsLoading(true);
    setProgress(0);

    // Simulate progress
    const timer = setTimeout(() => {
      setProgress(100);
    }, 100);

    const completeTimer = setTimeout(() => {
      setIsLoading(false);
      setProgress(0);
    }, 450);

    return () => {
      clearTimeout(timer);
      clearTimeout(completeTimer);
    };
  }, [location]);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          className="navigation-progress"
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <div 
            className="navigation-progress-bar"
            style={{ width: `${progress}%` }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NavigationProgress;
